import React from "react";
// eslint-disable-next-line no-restricted-imports
import * as Dropdown from "@radix-ui/react-dropdown-menu";
import { useHistory } from "react-router";
import { colors, styled } from "../../../stitches.config";
import { Icon, IconNames } from "../Icons/LucideIcons";
import {
  TagContainer,
  TagIconWrapper,
  TagLabelWrapper,
  TagStyles,
} from "./__styles__/PressableTag";

export type PressableTagProps = {
  label: string;
  href?: string;
  to?: string;
  iconName?: IconNames;
  asDropdownItem?: boolean;
  color?: keyof typeof colors;
  iconColor?: keyof typeof colors;
  onClick?: (e: React.MouseEvent) => void;
};

export const PressableTag = ({
  label,
  iconName,
  href,
  to,
  asDropdownItem,
  color,
  iconColor,
  onClick,
}: PressableTagProps) => {
  const history = useHistory();

  const contents = (
    <>
      {iconName && (
        <TagIconWrapper>
          <Icon
            iconName={iconName}
            color={iconColor || "contentSecondary"}
            size={16}
          />
        </TagIconWrapper>
      )}
      <TagLabelWrapper
        style={{
          textDecoration: !!href || !!to || !!onClick ? "underline" : "none",
        }}
      >
        {label}
      </TagLabelWrapper>
    </>
  );

  if (asDropdownItem) {
    if (href) {
      return (
        <DropdownItem asChild>
          <a href={href} style={{ textDecoration: "none" }} target="_blank">
            {contents}
          </a>
        </DropdownItem>
      );
    }
    if (to) {
      const onSelect = () =>
        history.push({
          pathname: to,
          state: { prevLocation: history.location },
        });

      return <DropdownItem onSelect={onSelect}>{contents}</DropdownItem>;
    }
    if (onClick) {
      return (
        <DropdownItem
          onSelect={() => {
            // This is needed because radix dropdown needs a mouse event to open
            const mockEvent = {
              stopPropagation: () => {},
              preventDefault: () => {},
            } as unknown as React.MouseEvent;
            onClick(mockEvent);
          }}
        >
          {contents}
        </DropdownItem>
      );
    }
  }

  return (
    <TagContainer
      style={{ background: colors[color || "bgUiInteraction"].value }}
      onClick={asDropdownItem ? onClick : undefined}
      data-tag-container="true"
    >
      {contents}
    </TagContainer>
  );
};

// This has to be in the same file and cannot live in the __styles__ file
// Moving to the styles file will break the dropdown when "asDropdownItem" is true
const DropdownItem = styled(Dropdown.Item, {
  ...TagStyles,
  "&:hover": {
    cursor: "pointer",
    outline: "unset",
  },
});
